<template>
  <div class="bg-cerise-red-600">
    <div
      class="container relative flex flex-col lg:flex-row justify-between space-y-8 sm:space-y-0 pb-10 lg:pb-0 items-center"
    >
      <nuxt-link to="/">
        <nuxt-img
          src="images/logo-mobile.png"
          alt="logo"
          class="w-[161px] mt-[44px] lg:mt-0 mb-1 h-8"
        />
      </nuxt-link>

      <div
        class="text-white text-center text-sm leading-5 lg:py-9 lg:pr-[75px]"
      >
        <div class="">© 2023 Prénatal S.p.A. - P.IVA 00857680151</div>
        <div class="">
          <div class="flex lg:gap-3 justify-center flex-col lg:flex-row">
            <nuxt-link
              class="underline cursor-pointer"
              to="https://www.prenatal.com/contact/"
              target="_blank"
            >
              Assistenza
            </nuxt-link>
            <nuxt-link
              class="underline cursor-pointer"
              to="https://www.prenatal.com/"
              target="_blank"
            >
              Store Online
            </nuxt-link>
          </div>
          <div class="flex lg:gap-3 justify-center flex-col lg:flex-row">
            <nuxt-link
              class="underline cursor-pointer"
              to="https://www.prenatal.com/privacy-policy/"
              target="_blank"
            >
              Informativa Privacy
            </nuxt-link>
            <nuxt-link
              class="underline cursor-pointer"
              to="https://www.prenatal.com/cookies/"
              target="_blank"
            >
              Cookie Policy
            </nuxt-link>
            <nuxt-link
              class="underline cursor-pointer"
              to="/regolamento-programma-fedelta"
              target="_blank"
            >
              Terms & Conditions
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-6 lg:gap-4 pt-1">
        <nuxt-link to="https://www.facebook.com/prenatalitalia" target="_blank">
          <nuxt-img
            src="images/facebook.svg"
            alt="facebook-icon"
            format="webp"
            class="w-6 max-h-full"
          />
        </nuxt-link>
        <nuxt-link
          to="https://www.youtube.com/user/prenatalworld"
          target="_blank"
        >
          <nuxt-img
            src="images/youtube.svg"
            alt="youtube-icon"
            format="webp"
            class="w-6 max-h-full"
          />
        </nuxt-link>
        <nuxt-link to="https://www.instagram.com/prenatal/" target="_blank">
          <nuxt-img
            src="images/instagram.svg"
            alt="instagram-icon"
            format="webp"
            class="w-6 max-h-full"
          />
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
